import { isRequired, isSmsCode, validate } from '../../services/validator'

const registerRules = {
  smscode:
    process.env.AUTH_PHONE_VERIFY === 'on'
      ? [val => isRequired(val, 'Введите код из смс'), isSmsCode]
      : undefined
}

export function validateCRVForm (values) {
  const errors = validate(
    {
      ...values,
      smscode: values.code
    },
    registerRules
  )

  return errors
}



// WEBPACK FOOTER //
// ./src/modules/crv/validations.js